/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PendingRouteImport } from './routes/pending'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as DevRouteImport } from './routes/dev'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlockedRouteImport } from './routes/blocked'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as PortalProfileRouteImport } from './routes/portal/profile'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as DashboardUtilitiesRouteImport } from './routes/dashboard/utilities'
import { Route as DashboardAnalyticsRouteImport } from './routes/dashboard/analytics'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardSettingsMarinaInfoRouteImport } from './routes/dashboard/settings/marina-info'
import { Route as DashboardSettingsBerthsRouteImport } from './routes/dashboard/settings/berths'
import { Route as DashboardSettingsAuditRouteImport } from './routes/dashboard/settings/audit'
import { Route as DashboardReservationsRequestsRouteImport } from './routes/dashboard/reservations/requests'
import { Route as DashboardReservationsBookingsRouteImport } from './routes/dashboard/reservations/bookings'
import { Route as DashboardReservationsIdRouteImport } from './routes/dashboard/reservations/$id'
import { Route as DashboardOccupancyMapRouteImport } from './routes/dashboard/occupancy/map'
import { Route as DashboardOccupancyCalendarRouteImport } from './routes/dashboard/occupancy/calendar'
import { Route as DashboardOccupancyArrivalsRouteImport } from './routes/dashboard/occupancy/arrivals'
import { Route as DashboardOccupancyAbsencesRouteImport } from './routes/dashboard/occupancy/absences'
import { Route as DashboardBookingsNewRouteImport } from './routes/dashboard/bookings/new'
import { Route as DashboardFacilityInventoryIndexRouteImport } from './routes/dashboard/facility/inventory/index'
import { Route as DashboardFacilityAssignmentsIndexRouteImport } from './routes/dashboard/facility/assignments/index'
import { Route as DashboardBillingQuotesIndexRouteImport } from './routes/dashboard/billing/quotes/index'
import { Route as DashboardBillingInvoicesIndexRouteImport } from './routes/dashboard/billing/invoices/index'
import { Route as DashboardAccountsCustomersIndexRouteImport } from './routes/dashboard/accounts/customers/index'
import { Route as DashboardAccountsContractsIndexRouteImport } from './routes/dashboard/accounts/contracts/index'
import { Route as DashboardAccountsBoatsIndexRouteImport } from './routes/dashboard/accounts/boats/index'
import { Route as DashboardFacilityInventoryNewRouteImport } from './routes/dashboard/facility/inventory/new'
import { Route as DashboardFacilityInventoryIdRouteImport } from './routes/dashboard/facility/inventory/$id'
import { Route as DashboardFacilityAssignmentsNewRouteImport } from './routes/dashboard/facility/assignments/new'
import { Route as DashboardFacilityAssignmentsIdRouteImport } from './routes/dashboard/facility/assignments/$id'
import { Route as DashboardBillingQuotesNewRouteImport } from './routes/dashboard/billing/quotes/new'
import { Route as DashboardBillingQuotesIdRouteImport } from './routes/dashboard/billing/quotes/$id'
import { Route as DashboardBillingInvoicesNewRouteImport } from './routes/dashboard/billing/invoices/new'
import { Route as DashboardBillingInvoicesIdRouteImport } from './routes/dashboard/billing/invoices/$id'
import { Route as DashboardAccountsCustomersNewRouteImport } from './routes/dashboard/accounts/customers/new'
import { Route as DashboardAccountsCustomersIdRouteImport } from './routes/dashboard/accounts/customers/$id'
import { Route as DashboardAccountsContractsNewRouteImport } from './routes/dashboard/accounts/contracts/new'
import { Route as DashboardAccountsContractsIdRouteImport } from './routes/dashboard/accounts/contracts/$id'
import { Route as DashboardAccountsBoatsNewRouteImport } from './routes/dashboard/accounts/boats/new'
import { Route as DashboardAccountsBoatsIdRouteImport } from './routes/dashboard/accounts/boats/$id'

const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockedRoute = BlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/portal/',
  path: '/portal/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const PortalProfileRoute = PortalProfileRouteImport.update({
  id: '/portal/profile',
  path: '/portal/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUtilitiesRoute = DashboardUtilitiesRouteImport.update({
  id: '/utilities',
  path: '/utilities',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsMarinaInfoRoute =
  DashboardSettingsMarinaInfoRouteImport.update({
    id: '/settings/marina-info',
    path: '/settings/marina-info',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsBerthsRoute = DashboardSettingsBerthsRouteImport.update({
  id: '/settings/berths',
  path: '/settings/berths',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsAuditRoute = DashboardSettingsAuditRouteImport.update({
  id: '/settings/audit',
  path: '/settings/audit',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReservationsRequestsRoute =
  DashboardReservationsRequestsRouteImport.update({
    id: '/reservations/requests',
    path: '/reservations/requests',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReservationsBookingsRoute =
  DashboardReservationsBookingsRouteImport.update({
    id: '/reservations/bookings',
    path: '/reservations/bookings',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReservationsIdRoute = DashboardReservationsIdRouteImport.update({
  id: '/reservations/$id',
  path: '/reservations/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOccupancyMapRoute = DashboardOccupancyMapRouteImport.update({
  id: '/occupancy/map',
  path: '/occupancy/map',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOccupancyCalendarRoute =
  DashboardOccupancyCalendarRouteImport.update({
    id: '/occupancy/calendar',
    path: '/occupancy/calendar',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardOccupancyArrivalsRoute =
  DashboardOccupancyArrivalsRouteImport.update({
    id: '/occupancy/arrivals',
    path: '/occupancy/arrivals',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardOccupancyAbsencesRoute =
  DashboardOccupancyAbsencesRouteImport.update({
    id: '/occupancy/absences',
    path: '/occupancy/absences',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBookingsNewRoute = DashboardBookingsNewRouteImport.update({
  id: '/bookings/new',
  path: '/bookings/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFacilityInventoryIndexRoute =
  DashboardFacilityInventoryIndexRouteImport.update({
    id: '/facility/inventory/',
    path: '/facility/inventory/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFacilityAssignmentsIndexRoute =
  DashboardFacilityAssignmentsIndexRouteImport.update({
    id: '/facility/assignments/',
    path: '/facility/assignments/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingQuotesIndexRoute =
  DashboardBillingQuotesIndexRouteImport.update({
    id: '/billing/quotes/',
    path: '/billing/quotes/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingInvoicesIndexRoute =
  DashboardBillingInvoicesIndexRouteImport.update({
    id: '/billing/invoices/',
    path: '/billing/invoices/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsCustomersIndexRoute =
  DashboardAccountsCustomersIndexRouteImport.update({
    id: '/accounts/customers/',
    path: '/accounts/customers/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsContractsIndexRoute =
  DashboardAccountsContractsIndexRouteImport.update({
    id: '/accounts/contracts/',
    path: '/accounts/contracts/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsBoatsIndexRoute =
  DashboardAccountsBoatsIndexRouteImport.update({
    id: '/accounts/boats/',
    path: '/accounts/boats/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFacilityInventoryNewRoute =
  DashboardFacilityInventoryNewRouteImport.update({
    id: '/facility/inventory/new',
    path: '/facility/inventory/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFacilityInventoryIdRoute =
  DashboardFacilityInventoryIdRouteImport.update({
    id: '/facility/inventory/$id',
    path: '/facility/inventory/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFacilityAssignmentsNewRoute =
  DashboardFacilityAssignmentsNewRouteImport.update({
    id: '/facility/assignments/new',
    path: '/facility/assignments/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardFacilityAssignmentsIdRoute =
  DashboardFacilityAssignmentsIdRouteImport.update({
    id: '/facility/assignments/$id',
    path: '/facility/assignments/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingQuotesNewRoute =
  DashboardBillingQuotesNewRouteImport.update({
    id: '/billing/quotes/new',
    path: '/billing/quotes/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingQuotesIdRoute =
  DashboardBillingQuotesIdRouteImport.update({
    id: '/billing/quotes/$id',
    path: '/billing/quotes/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingInvoicesNewRoute =
  DashboardBillingInvoicesNewRouteImport.update({
    id: '/billing/invoices/new',
    path: '/billing/invoices/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingInvoicesIdRoute =
  DashboardBillingInvoicesIdRouteImport.update({
    id: '/billing/invoices/$id',
    path: '/billing/invoices/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsCustomersNewRoute =
  DashboardAccountsCustomersNewRouteImport.update({
    id: '/accounts/customers/new',
    path: '/accounts/customers/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsCustomersIdRoute =
  DashboardAccountsCustomersIdRouteImport.update({
    id: '/accounts/customers/$id',
    path: '/accounts/customers/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsContractsNewRoute =
  DashboardAccountsContractsNewRouteImport.update({
    id: '/accounts/contracts/new',
    path: '/accounts/contracts/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsContractsIdRoute =
  DashboardAccountsContractsIdRouteImport.update({
    id: '/accounts/contracts/$id',
    path: '/accounts/contracts/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsBoatsNewRoute =
  DashboardAccountsBoatsNewRouteImport.update({
    id: '/accounts/boats/new',
    path: '/accounts/boats/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAccountsBoatsIdRoute =
  DashboardAccountsBoatsIdRouteImport.update({
    id: '/accounts/boats/$id',
    path: '/accounts/boats/$id',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blocked': typeof BlockedRoute
  '/contact': typeof ContactRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dev': typeof DevRoute
  '/features': typeof FeaturesRoute
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/utilities': typeof DashboardUtilitiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/portal/profile': typeof PortalProfileRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/dashboard/bookings/new': typeof DashboardBookingsNewRoute
  '/dashboard/occupancy/absences': typeof DashboardOccupancyAbsencesRoute
  '/dashboard/occupancy/arrivals': typeof DashboardOccupancyArrivalsRoute
  '/dashboard/occupancy/calendar': typeof DashboardOccupancyCalendarRoute
  '/dashboard/occupancy/map': typeof DashboardOccupancyMapRoute
  '/dashboard/reservations/$id': typeof DashboardReservationsIdRoute
  '/dashboard/reservations/bookings': typeof DashboardReservationsBookingsRoute
  '/dashboard/reservations/requests': typeof DashboardReservationsRequestsRoute
  '/dashboard/settings/audit': typeof DashboardSettingsAuditRoute
  '/dashboard/settings/berths': typeof DashboardSettingsBerthsRoute
  '/dashboard/settings/marina-info': typeof DashboardSettingsMarinaInfoRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/accounts/boats/$id': typeof DashboardAccountsBoatsIdRoute
  '/dashboard/accounts/boats/new': typeof DashboardAccountsBoatsNewRoute
  '/dashboard/accounts/contracts/$id': typeof DashboardAccountsContractsIdRoute
  '/dashboard/accounts/contracts/new': typeof DashboardAccountsContractsNewRoute
  '/dashboard/accounts/customers/$id': typeof DashboardAccountsCustomersIdRoute
  '/dashboard/accounts/customers/new': typeof DashboardAccountsCustomersNewRoute
  '/dashboard/billing/invoices/$id': typeof DashboardBillingInvoicesIdRoute
  '/dashboard/billing/invoices/new': typeof DashboardBillingInvoicesNewRoute
  '/dashboard/billing/quotes/$id': typeof DashboardBillingQuotesIdRoute
  '/dashboard/billing/quotes/new': typeof DashboardBillingQuotesNewRoute
  '/dashboard/facility/assignments/$id': typeof DashboardFacilityAssignmentsIdRoute
  '/dashboard/facility/assignments/new': typeof DashboardFacilityAssignmentsNewRoute
  '/dashboard/facility/inventory/$id': typeof DashboardFacilityInventoryIdRoute
  '/dashboard/facility/inventory/new': typeof DashboardFacilityInventoryNewRoute
  '/dashboard/accounts/boats/': typeof DashboardAccountsBoatsIndexRoute
  '/dashboard/accounts/contracts/': typeof DashboardAccountsContractsIndexRoute
  '/dashboard/accounts/customers/': typeof DashboardAccountsCustomersIndexRoute
  '/dashboard/billing/invoices/': typeof DashboardBillingInvoicesIndexRoute
  '/dashboard/billing/quotes/': typeof DashboardBillingQuotesIndexRoute
  '/dashboard/facility/assignments/': typeof DashboardFacilityAssignmentsIndexRoute
  '/dashboard/facility/inventory/': typeof DashboardFacilityInventoryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blocked': typeof BlockedRoute
  '/contact': typeof ContactRoute
  '/dev': typeof DevRoute
  '/features': typeof FeaturesRoute
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/utilities': typeof DashboardUtilitiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/portal/profile': typeof PortalProfileRoute
  '/dashboard': typeof DashboardIndexRoute
  '/portal': typeof PortalIndexRoute
  '/dashboard/bookings/new': typeof DashboardBookingsNewRoute
  '/dashboard/occupancy/absences': typeof DashboardOccupancyAbsencesRoute
  '/dashboard/occupancy/arrivals': typeof DashboardOccupancyArrivalsRoute
  '/dashboard/occupancy/calendar': typeof DashboardOccupancyCalendarRoute
  '/dashboard/occupancy/map': typeof DashboardOccupancyMapRoute
  '/dashboard/reservations/$id': typeof DashboardReservationsIdRoute
  '/dashboard/reservations/bookings': typeof DashboardReservationsBookingsRoute
  '/dashboard/reservations/requests': typeof DashboardReservationsRequestsRoute
  '/dashboard/settings/audit': typeof DashboardSettingsAuditRoute
  '/dashboard/settings/berths': typeof DashboardSettingsBerthsRoute
  '/dashboard/settings/marina-info': typeof DashboardSettingsMarinaInfoRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/accounts/boats/$id': typeof DashboardAccountsBoatsIdRoute
  '/dashboard/accounts/boats/new': typeof DashboardAccountsBoatsNewRoute
  '/dashboard/accounts/contracts/$id': typeof DashboardAccountsContractsIdRoute
  '/dashboard/accounts/contracts/new': typeof DashboardAccountsContractsNewRoute
  '/dashboard/accounts/customers/$id': typeof DashboardAccountsCustomersIdRoute
  '/dashboard/accounts/customers/new': typeof DashboardAccountsCustomersNewRoute
  '/dashboard/billing/invoices/$id': typeof DashboardBillingInvoicesIdRoute
  '/dashboard/billing/invoices/new': typeof DashboardBillingInvoicesNewRoute
  '/dashboard/billing/quotes/$id': typeof DashboardBillingQuotesIdRoute
  '/dashboard/billing/quotes/new': typeof DashboardBillingQuotesNewRoute
  '/dashboard/facility/assignments/$id': typeof DashboardFacilityAssignmentsIdRoute
  '/dashboard/facility/assignments/new': typeof DashboardFacilityAssignmentsNewRoute
  '/dashboard/facility/inventory/$id': typeof DashboardFacilityInventoryIdRoute
  '/dashboard/facility/inventory/new': typeof DashboardFacilityInventoryNewRoute
  '/dashboard/accounts/boats': typeof DashboardAccountsBoatsIndexRoute
  '/dashboard/accounts/contracts': typeof DashboardAccountsContractsIndexRoute
  '/dashboard/accounts/customers': typeof DashboardAccountsCustomersIndexRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesIndexRoute
  '/dashboard/billing/quotes': typeof DashboardBillingQuotesIndexRoute
  '/dashboard/facility/assignments': typeof DashboardFacilityAssignmentsIndexRoute
  '/dashboard/facility/inventory': typeof DashboardFacilityInventoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blocked': typeof BlockedRoute
  '/contact': typeof ContactRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dev': typeof DevRoute
  '/features': typeof FeaturesRoute
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/utilities': typeof DashboardUtilitiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/portal/profile': typeof PortalProfileRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/dashboard/bookings/new': typeof DashboardBookingsNewRoute
  '/dashboard/occupancy/absences': typeof DashboardOccupancyAbsencesRoute
  '/dashboard/occupancy/arrivals': typeof DashboardOccupancyArrivalsRoute
  '/dashboard/occupancy/calendar': typeof DashboardOccupancyCalendarRoute
  '/dashboard/occupancy/map': typeof DashboardOccupancyMapRoute
  '/dashboard/reservations/$id': typeof DashboardReservationsIdRoute
  '/dashboard/reservations/bookings': typeof DashboardReservationsBookingsRoute
  '/dashboard/reservations/requests': typeof DashboardReservationsRequestsRoute
  '/dashboard/settings/audit': typeof DashboardSettingsAuditRoute
  '/dashboard/settings/berths': typeof DashboardSettingsBerthsRoute
  '/dashboard/settings/marina-info': typeof DashboardSettingsMarinaInfoRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/accounts/boats/$id': typeof DashboardAccountsBoatsIdRoute
  '/dashboard/accounts/boats/new': typeof DashboardAccountsBoatsNewRoute
  '/dashboard/accounts/contracts/$id': typeof DashboardAccountsContractsIdRoute
  '/dashboard/accounts/contracts/new': typeof DashboardAccountsContractsNewRoute
  '/dashboard/accounts/customers/$id': typeof DashboardAccountsCustomersIdRoute
  '/dashboard/accounts/customers/new': typeof DashboardAccountsCustomersNewRoute
  '/dashboard/billing/invoices/$id': typeof DashboardBillingInvoicesIdRoute
  '/dashboard/billing/invoices/new': typeof DashboardBillingInvoicesNewRoute
  '/dashboard/billing/quotes/$id': typeof DashboardBillingQuotesIdRoute
  '/dashboard/billing/quotes/new': typeof DashboardBillingQuotesNewRoute
  '/dashboard/facility/assignments/$id': typeof DashboardFacilityAssignmentsIdRoute
  '/dashboard/facility/assignments/new': typeof DashboardFacilityAssignmentsNewRoute
  '/dashboard/facility/inventory/$id': typeof DashboardFacilityInventoryIdRoute
  '/dashboard/facility/inventory/new': typeof DashboardFacilityInventoryNewRoute
  '/dashboard/accounts/boats/': typeof DashboardAccountsBoatsIndexRoute
  '/dashboard/accounts/contracts/': typeof DashboardAccountsContractsIndexRoute
  '/dashboard/accounts/customers/': typeof DashboardAccountsCustomersIndexRoute
  '/dashboard/billing/invoices/': typeof DashboardBillingInvoicesIndexRoute
  '/dashboard/billing/quotes/': typeof DashboardBillingQuotesIndexRoute
  '/dashboard/facility/assignments/': typeof DashboardFacilityAssignmentsIndexRoute
  '/dashboard/facility/inventory/': typeof DashboardFacilityInventoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blocked'
    | '/contact'
    | '/dashboard'
    | '/dev'
    | '/features'
    | '/login'
    | '/pending'
    | '/pricing'
    | '/profile'
    | '/dashboard/analytics'
    | '/dashboard/utilities'
    | '/legal/privacy'
    | '/legal/terms'
    | '/portal/profile'
    | '/dashboard/'
    | '/portal/'
    | '/dashboard/bookings/new'
    | '/dashboard/occupancy/absences'
    | '/dashboard/occupancy/arrivals'
    | '/dashboard/occupancy/calendar'
    | '/dashboard/occupancy/map'
    | '/dashboard/reservations/$id'
    | '/dashboard/reservations/bookings'
    | '/dashboard/reservations/requests'
    | '/dashboard/settings/audit'
    | '/dashboard/settings/berths'
    | '/dashboard/settings/marina-info'
    | '/dashboard/settings/'
    | '/dashboard/accounts/boats/$id'
    | '/dashboard/accounts/boats/new'
    | '/dashboard/accounts/contracts/$id'
    | '/dashboard/accounts/contracts/new'
    | '/dashboard/accounts/customers/$id'
    | '/dashboard/accounts/customers/new'
    | '/dashboard/billing/invoices/$id'
    | '/dashboard/billing/invoices/new'
    | '/dashboard/billing/quotes/$id'
    | '/dashboard/billing/quotes/new'
    | '/dashboard/facility/assignments/$id'
    | '/dashboard/facility/assignments/new'
    | '/dashboard/facility/inventory/$id'
    | '/dashboard/facility/inventory/new'
    | '/dashboard/accounts/boats/'
    | '/dashboard/accounts/contracts/'
    | '/dashboard/accounts/customers/'
    | '/dashboard/billing/invoices/'
    | '/dashboard/billing/quotes/'
    | '/dashboard/facility/assignments/'
    | '/dashboard/facility/inventory/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blocked'
    | '/contact'
    | '/dev'
    | '/features'
    | '/login'
    | '/pending'
    | '/pricing'
    | '/profile'
    | '/dashboard/analytics'
    | '/dashboard/utilities'
    | '/legal/privacy'
    | '/legal/terms'
    | '/portal/profile'
    | '/dashboard'
    | '/portal'
    | '/dashboard/bookings/new'
    | '/dashboard/occupancy/absences'
    | '/dashboard/occupancy/arrivals'
    | '/dashboard/occupancy/calendar'
    | '/dashboard/occupancy/map'
    | '/dashboard/reservations/$id'
    | '/dashboard/reservations/bookings'
    | '/dashboard/reservations/requests'
    | '/dashboard/settings/audit'
    | '/dashboard/settings/berths'
    | '/dashboard/settings/marina-info'
    | '/dashboard/settings'
    | '/dashboard/accounts/boats/$id'
    | '/dashboard/accounts/boats/new'
    | '/dashboard/accounts/contracts/$id'
    | '/dashboard/accounts/contracts/new'
    | '/dashboard/accounts/customers/$id'
    | '/dashboard/accounts/customers/new'
    | '/dashboard/billing/invoices/$id'
    | '/dashboard/billing/invoices/new'
    | '/dashboard/billing/quotes/$id'
    | '/dashboard/billing/quotes/new'
    | '/dashboard/facility/assignments/$id'
    | '/dashboard/facility/assignments/new'
    | '/dashboard/facility/inventory/$id'
    | '/dashboard/facility/inventory/new'
    | '/dashboard/accounts/boats'
    | '/dashboard/accounts/contracts'
    | '/dashboard/accounts/customers'
    | '/dashboard/billing/invoices'
    | '/dashboard/billing/quotes'
    | '/dashboard/facility/assignments'
    | '/dashboard/facility/inventory'
  id:
    | '__root__'
    | '/'
    | '/blocked'
    | '/contact'
    | '/dashboard'
    | '/dev'
    | '/features'
    | '/login'
    | '/pending'
    | '/pricing'
    | '/profile'
    | '/dashboard/analytics'
    | '/dashboard/utilities'
    | '/legal/privacy'
    | '/legal/terms'
    | '/portal/profile'
    | '/dashboard/'
    | '/portal/'
    | '/dashboard/bookings/new'
    | '/dashboard/occupancy/absences'
    | '/dashboard/occupancy/arrivals'
    | '/dashboard/occupancy/calendar'
    | '/dashboard/occupancy/map'
    | '/dashboard/reservations/$id'
    | '/dashboard/reservations/bookings'
    | '/dashboard/reservations/requests'
    | '/dashboard/settings/audit'
    | '/dashboard/settings/berths'
    | '/dashboard/settings/marina-info'
    | '/dashboard/settings/'
    | '/dashboard/accounts/boats/$id'
    | '/dashboard/accounts/boats/new'
    | '/dashboard/accounts/contracts/$id'
    | '/dashboard/accounts/contracts/new'
    | '/dashboard/accounts/customers/$id'
    | '/dashboard/accounts/customers/new'
    | '/dashboard/billing/invoices/$id'
    | '/dashboard/billing/invoices/new'
    | '/dashboard/billing/quotes/$id'
    | '/dashboard/billing/quotes/new'
    | '/dashboard/facility/assignments/$id'
    | '/dashboard/facility/assignments/new'
    | '/dashboard/facility/inventory/$id'
    | '/dashboard/facility/inventory/new'
    | '/dashboard/accounts/boats/'
    | '/dashboard/accounts/contracts/'
    | '/dashboard/accounts/customers/'
    | '/dashboard/billing/invoices/'
    | '/dashboard/billing/quotes/'
    | '/dashboard/facility/assignments/'
    | '/dashboard/facility/inventory/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlockedRoute: typeof BlockedRoute
  ContactRoute: typeof ContactRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  DevRoute: typeof DevRoute
  FeaturesRoute: typeof FeaturesRoute
  LoginRoute: typeof LoginRoute
  PendingRoute: typeof PendingRoute
  PricingRoute: typeof PricingRoute
  ProfileRoute: typeof ProfileRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
  PortalProfileRoute: typeof PortalProfileRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocked': {
      id: '/blocked'
      path: '/blocked'
      fullPath: '/blocked'
      preLoaderRoute: typeof BlockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/portal'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/portal/profile': {
      id: '/portal/profile'
      path: '/portal/profile'
      fullPath: '/portal/profile'
      preLoaderRoute: typeof PortalProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/utilities': {
      id: '/dashboard/utilities'
      path: '/utilities'
      fullPath: '/dashboard/utilities'
      preLoaderRoute: typeof DashboardUtilitiesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics': {
      id: '/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/settings'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/marina-info': {
      id: '/dashboard/settings/marina-info'
      path: '/settings/marina-info'
      fullPath: '/dashboard/settings/marina-info'
      preLoaderRoute: typeof DashboardSettingsMarinaInfoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/berths': {
      id: '/dashboard/settings/berths'
      path: '/settings/berths'
      fullPath: '/dashboard/settings/berths'
      preLoaderRoute: typeof DashboardSettingsBerthsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/audit': {
      id: '/dashboard/settings/audit'
      path: '/settings/audit'
      fullPath: '/dashboard/settings/audit'
      preLoaderRoute: typeof DashboardSettingsAuditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reservations/requests': {
      id: '/dashboard/reservations/requests'
      path: '/reservations/requests'
      fullPath: '/dashboard/reservations/requests'
      preLoaderRoute: typeof DashboardReservationsRequestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reservations/bookings': {
      id: '/dashboard/reservations/bookings'
      path: '/reservations/bookings'
      fullPath: '/dashboard/reservations/bookings'
      preLoaderRoute: typeof DashboardReservationsBookingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reservations/$id': {
      id: '/dashboard/reservations/$id'
      path: '/reservations/$id'
      fullPath: '/dashboard/reservations/$id'
      preLoaderRoute: typeof DashboardReservationsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/occupancy/map': {
      id: '/dashboard/occupancy/map'
      path: '/occupancy/map'
      fullPath: '/dashboard/occupancy/map'
      preLoaderRoute: typeof DashboardOccupancyMapRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/occupancy/calendar': {
      id: '/dashboard/occupancy/calendar'
      path: '/occupancy/calendar'
      fullPath: '/dashboard/occupancy/calendar'
      preLoaderRoute: typeof DashboardOccupancyCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/occupancy/arrivals': {
      id: '/dashboard/occupancy/arrivals'
      path: '/occupancy/arrivals'
      fullPath: '/dashboard/occupancy/arrivals'
      preLoaderRoute: typeof DashboardOccupancyArrivalsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/occupancy/absences': {
      id: '/dashboard/occupancy/absences'
      path: '/occupancy/absences'
      fullPath: '/dashboard/occupancy/absences'
      preLoaderRoute: typeof DashboardOccupancyAbsencesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/bookings/new': {
      id: '/dashboard/bookings/new'
      path: '/bookings/new'
      fullPath: '/dashboard/bookings/new'
      preLoaderRoute: typeof DashboardBookingsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/inventory/': {
      id: '/dashboard/facility/inventory/'
      path: '/facility/inventory'
      fullPath: '/dashboard/facility/inventory/'
      preLoaderRoute: typeof DashboardFacilityInventoryIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/assignments/': {
      id: '/dashboard/facility/assignments/'
      path: '/facility/assignments'
      fullPath: '/dashboard/facility/assignments/'
      preLoaderRoute: typeof DashboardFacilityAssignmentsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/quotes/': {
      id: '/dashboard/billing/quotes/'
      path: '/billing/quotes'
      fullPath: '/dashboard/billing/quotes/'
      preLoaderRoute: typeof DashboardBillingQuotesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/invoices/': {
      id: '/dashboard/billing/invoices/'
      path: '/billing/invoices'
      fullPath: '/dashboard/billing/invoices/'
      preLoaderRoute: typeof DashboardBillingInvoicesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/customers/': {
      id: '/dashboard/accounts/customers/'
      path: '/accounts/customers'
      fullPath: '/dashboard/accounts/customers/'
      preLoaderRoute: typeof DashboardAccountsCustomersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/contracts/': {
      id: '/dashboard/accounts/contracts/'
      path: '/accounts/contracts'
      fullPath: '/dashboard/accounts/contracts/'
      preLoaderRoute: typeof DashboardAccountsContractsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/boats/': {
      id: '/dashboard/accounts/boats/'
      path: '/accounts/boats'
      fullPath: '/dashboard/accounts/boats/'
      preLoaderRoute: typeof DashboardAccountsBoatsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/inventory/new': {
      id: '/dashboard/facility/inventory/new'
      path: '/facility/inventory/new'
      fullPath: '/dashboard/facility/inventory/new'
      preLoaderRoute: typeof DashboardFacilityInventoryNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/inventory/$id': {
      id: '/dashboard/facility/inventory/$id'
      path: '/facility/inventory/$id'
      fullPath: '/dashboard/facility/inventory/$id'
      preLoaderRoute: typeof DashboardFacilityInventoryIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/assignments/new': {
      id: '/dashboard/facility/assignments/new'
      path: '/facility/assignments/new'
      fullPath: '/dashboard/facility/assignments/new'
      preLoaderRoute: typeof DashboardFacilityAssignmentsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/facility/assignments/$id': {
      id: '/dashboard/facility/assignments/$id'
      path: '/facility/assignments/$id'
      fullPath: '/dashboard/facility/assignments/$id'
      preLoaderRoute: typeof DashboardFacilityAssignmentsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/quotes/new': {
      id: '/dashboard/billing/quotes/new'
      path: '/billing/quotes/new'
      fullPath: '/dashboard/billing/quotes/new'
      preLoaderRoute: typeof DashboardBillingQuotesNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/quotes/$id': {
      id: '/dashboard/billing/quotes/$id'
      path: '/billing/quotes/$id'
      fullPath: '/dashboard/billing/quotes/$id'
      preLoaderRoute: typeof DashboardBillingQuotesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/invoices/new': {
      id: '/dashboard/billing/invoices/new'
      path: '/billing/invoices/new'
      fullPath: '/dashboard/billing/invoices/new'
      preLoaderRoute: typeof DashboardBillingInvoicesNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/invoices/$id': {
      id: '/dashboard/billing/invoices/$id'
      path: '/billing/invoices/$id'
      fullPath: '/dashboard/billing/invoices/$id'
      preLoaderRoute: typeof DashboardBillingInvoicesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/customers/new': {
      id: '/dashboard/accounts/customers/new'
      path: '/accounts/customers/new'
      fullPath: '/dashboard/accounts/customers/new'
      preLoaderRoute: typeof DashboardAccountsCustomersNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/customers/$id': {
      id: '/dashboard/accounts/customers/$id'
      path: '/accounts/customers/$id'
      fullPath: '/dashboard/accounts/customers/$id'
      preLoaderRoute: typeof DashboardAccountsCustomersIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/contracts/new': {
      id: '/dashboard/accounts/contracts/new'
      path: '/accounts/contracts/new'
      fullPath: '/dashboard/accounts/contracts/new'
      preLoaderRoute: typeof DashboardAccountsContractsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/contracts/$id': {
      id: '/dashboard/accounts/contracts/$id'
      path: '/accounts/contracts/$id'
      fullPath: '/dashboard/accounts/contracts/$id'
      preLoaderRoute: typeof DashboardAccountsContractsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/boats/new': {
      id: '/dashboard/accounts/boats/new'
      path: '/accounts/boats/new'
      fullPath: '/dashboard/accounts/boats/new'
      preLoaderRoute: typeof DashboardAccountsBoatsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/accounts/boats/$id': {
      id: '/dashboard/accounts/boats/$id'
      path: '/accounts/boats/$id'
      fullPath: '/dashboard/accounts/boats/$id'
      preLoaderRoute: typeof DashboardAccountsBoatsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAnalyticsRoute: typeof DashboardAnalyticsRoute
  DashboardUtilitiesRoute: typeof DashboardUtilitiesRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardBookingsNewRoute: typeof DashboardBookingsNewRoute
  DashboardOccupancyAbsencesRoute: typeof DashboardOccupancyAbsencesRoute
  DashboardOccupancyArrivalsRoute: typeof DashboardOccupancyArrivalsRoute
  DashboardOccupancyCalendarRoute: typeof DashboardOccupancyCalendarRoute
  DashboardOccupancyMapRoute: typeof DashboardOccupancyMapRoute
  DashboardReservationsIdRoute: typeof DashboardReservationsIdRoute
  DashboardReservationsBookingsRoute: typeof DashboardReservationsBookingsRoute
  DashboardReservationsRequestsRoute: typeof DashboardReservationsRequestsRoute
  DashboardSettingsAuditRoute: typeof DashboardSettingsAuditRoute
  DashboardSettingsBerthsRoute: typeof DashboardSettingsBerthsRoute
  DashboardSettingsMarinaInfoRoute: typeof DashboardSettingsMarinaInfoRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardAccountsBoatsIdRoute: typeof DashboardAccountsBoatsIdRoute
  DashboardAccountsBoatsNewRoute: typeof DashboardAccountsBoatsNewRoute
  DashboardAccountsContractsIdRoute: typeof DashboardAccountsContractsIdRoute
  DashboardAccountsContractsNewRoute: typeof DashboardAccountsContractsNewRoute
  DashboardAccountsCustomersIdRoute: typeof DashboardAccountsCustomersIdRoute
  DashboardAccountsCustomersNewRoute: typeof DashboardAccountsCustomersNewRoute
  DashboardBillingInvoicesIdRoute: typeof DashboardBillingInvoicesIdRoute
  DashboardBillingInvoicesNewRoute: typeof DashboardBillingInvoicesNewRoute
  DashboardBillingQuotesIdRoute: typeof DashboardBillingQuotesIdRoute
  DashboardBillingQuotesNewRoute: typeof DashboardBillingQuotesNewRoute
  DashboardFacilityAssignmentsIdRoute: typeof DashboardFacilityAssignmentsIdRoute
  DashboardFacilityAssignmentsNewRoute: typeof DashboardFacilityAssignmentsNewRoute
  DashboardFacilityInventoryIdRoute: typeof DashboardFacilityInventoryIdRoute
  DashboardFacilityInventoryNewRoute: typeof DashboardFacilityInventoryNewRoute
  DashboardAccountsBoatsIndexRoute: typeof DashboardAccountsBoatsIndexRoute
  DashboardAccountsContractsIndexRoute: typeof DashboardAccountsContractsIndexRoute
  DashboardAccountsCustomersIndexRoute: typeof DashboardAccountsCustomersIndexRoute
  DashboardBillingInvoicesIndexRoute: typeof DashboardBillingInvoicesIndexRoute
  DashboardBillingQuotesIndexRoute: typeof DashboardBillingQuotesIndexRoute
  DashboardFacilityAssignmentsIndexRoute: typeof DashboardFacilityAssignmentsIndexRoute
  DashboardFacilityInventoryIndexRoute: typeof DashboardFacilityInventoryIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAnalyticsRoute: DashboardAnalyticsRoute,
  DashboardUtilitiesRoute: DashboardUtilitiesRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardBookingsNewRoute: DashboardBookingsNewRoute,
  DashboardOccupancyAbsencesRoute: DashboardOccupancyAbsencesRoute,
  DashboardOccupancyArrivalsRoute: DashboardOccupancyArrivalsRoute,
  DashboardOccupancyCalendarRoute: DashboardOccupancyCalendarRoute,
  DashboardOccupancyMapRoute: DashboardOccupancyMapRoute,
  DashboardReservationsIdRoute: DashboardReservationsIdRoute,
  DashboardReservationsBookingsRoute: DashboardReservationsBookingsRoute,
  DashboardReservationsRequestsRoute: DashboardReservationsRequestsRoute,
  DashboardSettingsAuditRoute: DashboardSettingsAuditRoute,
  DashboardSettingsBerthsRoute: DashboardSettingsBerthsRoute,
  DashboardSettingsMarinaInfoRoute: DashboardSettingsMarinaInfoRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  DashboardAccountsBoatsIdRoute: DashboardAccountsBoatsIdRoute,
  DashboardAccountsBoatsNewRoute: DashboardAccountsBoatsNewRoute,
  DashboardAccountsContractsIdRoute: DashboardAccountsContractsIdRoute,
  DashboardAccountsContractsNewRoute: DashboardAccountsContractsNewRoute,
  DashboardAccountsCustomersIdRoute: DashboardAccountsCustomersIdRoute,
  DashboardAccountsCustomersNewRoute: DashboardAccountsCustomersNewRoute,
  DashboardBillingInvoicesIdRoute: DashboardBillingInvoicesIdRoute,
  DashboardBillingInvoicesNewRoute: DashboardBillingInvoicesNewRoute,
  DashboardBillingQuotesIdRoute: DashboardBillingQuotesIdRoute,
  DashboardBillingQuotesNewRoute: DashboardBillingQuotesNewRoute,
  DashboardFacilityAssignmentsIdRoute: DashboardFacilityAssignmentsIdRoute,
  DashboardFacilityAssignmentsNewRoute: DashboardFacilityAssignmentsNewRoute,
  DashboardFacilityInventoryIdRoute: DashboardFacilityInventoryIdRoute,
  DashboardFacilityInventoryNewRoute: DashboardFacilityInventoryNewRoute,
  DashboardAccountsBoatsIndexRoute: DashboardAccountsBoatsIndexRoute,
  DashboardAccountsContractsIndexRoute: DashboardAccountsContractsIndexRoute,
  DashboardAccountsCustomersIndexRoute: DashboardAccountsCustomersIndexRoute,
  DashboardBillingInvoicesIndexRoute: DashboardBillingInvoicesIndexRoute,
  DashboardBillingQuotesIndexRoute: DashboardBillingQuotesIndexRoute,
  DashboardFacilityAssignmentsIndexRoute:
    DashboardFacilityAssignmentsIndexRoute,
  DashboardFacilityInventoryIndexRoute: DashboardFacilityInventoryIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlockedRoute: BlockedRoute,
  ContactRoute: ContactRoute,
  DashboardRoute: DashboardRouteWithChildren,
  DevRoute: DevRoute,
  FeaturesRoute: FeaturesRoute,
  LoginRoute: LoginRoute,
  PendingRoute: PendingRoute,
  PricingRoute: PricingRoute,
  ProfileRoute: ProfileRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
  PortalProfileRoute: PortalProfileRoute,
  PortalIndexRoute: PortalIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
